import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfWebView } from '@infakt/webview-toolkit';

export default class extends Controller {
  static values = {
    url: String,
    oid: String,
    oids: Array,
    paymentSource: String,
    paymentFor: String,
  };

  async openPaymentPage(event) {
    event.preventDefault();

    if (!checkIfWebView()) {
      return;
    }

    const requestData = {
      payment_source: this.paymentSourceValue,
      payment_for: this.paymentForValue,
    };

    if (['table', 'timeline'].includes(this.paymentSourceValue) && !!this.oidValue) {
      requestData.oid = this.oidValue;
    } else if (this.paymentSourceValue === 'timeline-multiple' && this.oidsValue.length > 0) {
      requestData.oids = this.oidsValue;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    const paymentUrlResponse = await fetch(this.urlValue, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify(requestData),
    });

    if (!paymentUrlResponse.ok) {
      return;
    }

    const parsedResponse = await paymentUrlResponse.json();

    if (parsedResponse.redirect) {
      window.location.href = parsedResponse.payment_link;
      return;
    }

    return new WebViewEvent({
      event: 'OpenInModal',
      params: {
        url: parsedResponse.payment_link,
        title: 'Opłać z inFakt',
        requireSession: false,
        externalLink: true,
      },
    }).dispatch();
  }
}
